module.exports = __webpack_public_path__ + "img/cart-masterclass-paid.cf857997.png";